import React from "react";
import styled from "styled-components";
import { withPrefix } from "gatsby";

const Wrapper = styled.div`
  &:first-child {
    .image-container {
      margin-top: 0;
    }
  }

  .image-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 2rem 0;

    .image {
      display: flex;
      img {
        margin: auto;
        max-width: 100%;
      }
    }
  }

  .no-image {
    background: #d8d8d8;
    height: 400px;
    width: 100%;
    border: 2px solid #979797;
  }

  .caption {
    color: ${({ theme }) => theme.secondary};
    padding: 8px 0;
  }
`;

type ImageProps = {
  src: string;
  alt?: string;
  caption?: string;
};

export const Image = ({ src, alt = "", caption = "" }: ImageProps) => {
  return (
    <Wrapper className="block">
      <div className="image-container">
        <div className="image" key={`image/${src}`}>
          <img src={withPrefix(`/${src}`)} alt={alt} />
        </div>
        <div
          className="caption"
          dangerouslySetInnerHTML={{ __html: caption }}
        />
      </div>
    </Wrapper>
  );
};
